import { render, staticRenderFns } from "./TripRestaurant.vue?vue&type=template&id=550393e8&"
import script from "./TripRestaurant.vue?vue&type=script&lang=js&"
export * from "./TripRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./TripRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports